(() => {
  if (window.lpPrimerSmoothScrollInitialized) return;
  window.lpPrimerSmoothScrollInitialized = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-lp-primer-smooth-scroll]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href || href === '#' || !href.startsWith('#')) return;

    const target = document.getElementById(href.slice(1));
    if (!target) return;

    event.preventDefault();
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    window.history.pushState(null, '', href);
  });
})();
